export function extractApiRequestMainPath(url) {
  if (!url) {
    return '';
  }

  if (!url.startsWith('/api')) {
    return url;
  }

  const [path, query] = url.split('?');
  const originalParams = new URLSearchParams(query);

  const reducedParams = new URLSearchParams({
    entity: originalParams.get('entity'),
    action: originalParams.get('action'),
  });

  return `${path}?${reducedParams.toString()}`;
}
